export const vehicleSize = [
  { id: "small", name: "Small", color: "#40c4ff" },
  { id: "medium", name: "Medium", color: "#795548" },
  { id: "large", name: "Large", color: "#7c4dff" },
];
